import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GameService } from '../services/game.service';
import { Level, LevelProgress } from '../_models/model';

@Injectable()
export class ProgressResolver implements Resolve<LevelProgress[]> {
  constructor(private game: GameService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<LevelProgress[]> {
    // console.log('progress resolver called');
    return this.game.loadProgressFromServer();

  }
}
